<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->

        <mat-dialog-content>
            <h2 class="mat-headline-5">{{ displayName }}</h2>

            <dash-gis-data-form-content [formName]="formData.name"
                                        [fieldValues]="formData.fields"
                                  (isValid)="isFormValid($event)"
                                  (setDisplayName)="setDisplayName($event)"
                                  (shouldClose)="shouldClose($event)" ></dash-gis-data-form-content>

        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button type="button" (click)="cancel()">Cancel</button>
            <button mat-button type="button"
                    (click)="saveData()" [disabled]="!formValidity">Save</button>
        </mat-dialog-actions>


